// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2INXd","primary":"Button_primary__K3ZYZ","cancel":"Button_cancel__yB0UM","small":"Button_small__3qmnT","disabled":"Button_disabled__1ZQn7"};